module.exports = __webpack_public_path__ + "img/fast-forward.d68bebf4.png";